export const mutation_addAnagraficaToFascicolo = `
    mutation addAnagraficaToFascicolo(
        $fascicoloId: Int!        
        $aziendaId: Int!
        $dataInput: InputAnagraficaFascicolo!
    ) {
        addAnagraficaToFascicolo(
            fascicoloId: $fascicoloId            
            aziendaId: $aziendaId
            dataInput: $dataInput
        ) {
            id
            fascicoloId
            anagraficaId
            tipoAnagId
            tipoPartId
            tipoPartDesc
            dataFine
            tipoRapp
            tipoRappDesc
        }
    }
`;
export const mutation_updateAnagraficaInFascicolo = `
    mutation updateAnagraficaInFascicolo(
        $fascicoloId: Int!
        $anagraficaFascicoloId: Int!        
        $aziendaId: Int!
        $dataInput: InputAnagraficaFascicoloUpdate!
    ) {
        updateAnagraficaInFascicolo(
            fascicoloId: $fascicoloId
            anagraficaFascicoloId: $anagraficaFascicoloId            
            aziendaId: $aziendaId
            dataInput: $dataInput
        ) {
            id
            anagraficaId
            fascicoloId
            tipoAnagId
            tipoPartId
            tipoPartDesc
            dataFine
            tipoRapp
            tipoRappDesc
        }
    }
`;
export const mutation_deleteAnagraficaFromFascicolo = `
    mutation deleteAnagraficaFromFascicolo(
        $fascicoloId: Int!
        $anagraficaFascicoloId: Int!        
        $aziendaId: Int!
    ) {
        deleteAnagraficaFromFascicolo(
            fascicoloId: $fascicoloId
            anagraficaFascicoloId: $anagraficaFascicoloId            
            aziendaId: $aziendaId
        ) {
            message
            deletedId
            storicoRecordsDeleted
        }
    }
`;

//#region OLD
export const mutation_getLegalRepresentatives = `
mutation getLegalRepresentatives($fascicoloId : Int!, $userId : String!, $isTerminated: Boolean!){
    getLegalRepresentatives(fascicoloId: $fascicoloId, userId : $userId, isTerminated:$isTerminated ){
        response
    }
}`;
export const mutation_update_PIva_anagrafica = `
mutation updateAnagrafica($id: Int!, $PIva: String!,$errWs:Boolean!,$errWsNote:String!) {
    update_anagrafica(where: {Id: {_eq: $id}}, _set: {PIva: $PIva,ErrWs:$errWs,ErrWsNote:$errWsNote}) {
        affected_rows
    }
}`;
//#endregion